<script setup lang="ts">
import { h, reactive, ref } from "vue";
import AdminLayout from "./AdminLayout.vue";
import { AdminFetcher } from "../../api/adminFetcher";
import { toastErr, toastOk } from "../../utils/toasts";
import { closeModal, removeAccModal } from "../../utils/programmingModals";
import { DataTableColumns, NButton, NDataTable, NSelect } from "naive-ui";
import { RowData } from "naive-ui/es/data-table/src/interface";

const loading = ref(true);

type Account = {
  id: string;
  login: string;
  role_id: string;
};

const accounts = reactive<Account[]>([]);
function getAccounts() {
  loading.value = true;
  AdminFetcher.get({
    path: "/superadmin/accounts",
  })
    .then((resp: Account[]) => {
      accounts.length = 0;
      accounts.push(...resp);
      loading.value = false;
    })
    .catch(() => {
      toastErr("Ошибка загрузки списка аккаунтов");
    });
}
getAccounts();

const removeAcc = async (login: string) => {
  removeAccModal(async () => {
    try {
      await AdminFetcher.delete({
        path: `/superadmin/${login}`,
      });
      getAccounts();
      toastOk("Успешно удалено");
      closeModal();
    } catch {
      toastErr("Ошибка удаления");
      closeModal();
    }
  });
};

const roles: {
  label: string;
  value: string;
}[] = reactive([]);
AdminFetcher.get({
  path: "/superadmin/roles",
}).then((resp: { id: string; name: string }[]) => {
  resp.forEach((item) => {
    roles.push({
      label: item.name,
      value: item.id,
    });
  });
});
async function updateRole(id: string, role: string) {
  await AdminFetcher.put({
    path: `/superadmin/${id}/role`,
    payload: {
      role_id: role,
    },
  });
  getAccounts();
}

function createColumns() {
  const cols: DataTableColumns<RowData> = [
    {
      title: "Логин",
      key: "login",
      sorter: "default",
      defaultSortOrder: "descend",
    },
    {
      title: "Роль",
      key: "role",
      render(row: RowData) {
        return h(NSelect, {
          value: row.role_id,
          options: roles,
          "onUpdate:value": (value: string) => {
            row.role_id = value;
            updateRole(row.id, value);
          },
        });
      },
    },
    {
      title: "Действия",
      key: "actions",
      render(row: RowData) {
        return h(
          NButton,
          {
            strong: true,
            secondary: true,
            type: "error",
            onClick: () => {
              removeAcc(row.login);
            },
          },
          {
            default: () => "Удалить",
          },
        );
      },
    },
  ];
  return cols;
}
const columns = createColumns();
</script>

<template>
  <AdminLayout>
    <template #header>
      <h4>Список аккаунтов</h4>
    </template>
    <div class="accounts-page">
      <NDataTable
        :columns="columns"
        :data="accounts"
        :loading="loading"
        :style="{
          height: '100%',
        }"
        flex-height
      ></NDataTable>
    </div>
  </AdminLayout>
</template>

<style lang="scss" scoped>
.accounts-page {
  padding: 20px;
  height: 100px;
  flex-grow: 1;
}
</style>
